/*----------------------------------
- TRACK WORKFLOW MOTION
- Decorative fake-data preview of a watched domain receiving change events.
----------------------------------*/

import type { IconName } from '@uniquedomains/components/ui/icon';
import Icon from '@/client/components/ui/icon/Icon';

/*----------------------------------
- CONTENT
----------------------------------*/

type WatchEvent = {
    icon: IconName;
    label: string;
    meta: string;
    tone: string;
};

const WATCH_EVENTS: readonly WatchEvent[] = [
    { icon: 'trending-down', label: 'Price drop', meta: '$1,584 → $1,374', tone: 'green' },
    { icon: 'clock', label: 'Auction ending', meta: '2h 14m left', tone: 'amber' },
    { icon: 'chart-line', label: 'New comparable', meta: 'Sale added today', tone: 'blue' },
] as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

const TrackWorkflowMotion = () => (
    <div aria-hidden="true" class="ud-workflow-track">
        <div class="ud-workflow-track__timeline">
            <span class="ud-workflow-track__timeline-line" />
            {WATCH_EVENTS.map((event, index) => (
                <div
                    key={event.label}
                    class={`ud-workflow-track__event ud-workflow-track__event--${event.tone}`}
                    style={{ animationDelay: `${index * 0.7}s` }}
                >
                    <span class="ud-workflow-track__event-icon">
                        <Icon name={event.icon} size={12} strokeWidth={2} />
                    </span>
                    <span class="ud-workflow-track__event-copy">
                        <strong>{event.label}</strong>
                        <span>{event.meta}</span>
                    </span>
                </div>
            ))}
        </div>

        <div class="ud-workflow-track__domain">
            <div class="ud-workflow-track__domain-topline">
                <span class="ud-workflow-track__watch-icon">
                    <Icon name="eye" size={13} strokeWidth={2} />
                </span>
                <span>Watching</span>
            </div>
            <strong class="ud-workflow-track__domain-name">signal.co</strong>
            <span class="ud-workflow-track__domain-meta">Current ask</span>
            <span class="ud-workflow-track__domain-price">$1,374</span>
        </div>
    </div>
);

export default TrackWorkflowMotion;
